class WishlistSharedPage extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.setupWishlist = this.setupWishlist.bind(this)

    this.populateSharedWishlist = this.populateSharedWishlist.bind(this)

    this.wishlistError = this.wishlistError.bind(this)

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      if (window._swat) {
        window._swat.fetchLists({
          callbackFn: this.populateSharedWishlist,
          errorFn: this.wishlistError,
        })
      }
    })
  }

  populateSharedWishlist () {
    const queryParams = window._swat.utils.getEncodedAsObject(
      window.location.search,
    )
    const listId = queryParams.lid

    const listConfig = {
      lid: listId,
    }

    window._swat.fetchListDetails(
      listConfig,
      this.setupWishlist,
      this.wishlistError,
    )
  }

  async setupWishlist (wishlist) {
    this.externalEls.text.element.textContent = `${window.theme.wishlist.viewingSharedList} ${wishlist.list.userinfo.em}`

    this.els['current-wishlist-text'].element.textContent =
      `${wishlist.list.lname} (${wishlist.list.cnt})`

    const productCardHTML = await this.getAllProductCardHTML(wishlist)
    this.els.products.element.innerHTML = productCardHTML

    if (wishlist.list.cnt > 0) {
      this.els['panel-list'].element.setAttribute('aria-hidden', false)
      this.els['panel-empty'].element.setAttribute('aria-hidden', true)
    } else {
      this.els['panel-list'].element.setAttribute('aria-hidden', true)
      this.els['panel-empty'].element.setAttribute('aria-hidden', false)
    }

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', true)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', false)
  }

  async getAllProductCardHTML (wishlist) {
    const productCardHTML = await Promise.all(
      wishlist.items.map(
        async (product, index) => await this.getProductCardHTML(product, index),
      ),
    )
    return productCardHTML.filter(Boolean).join('')
  }

  async getProductCardHTML (product, index) {
    const productUrl = product.du.replace(
      '/products/',
      `${window.Shopify.routes.root}products/`,
    )

    return window.BAO.sectionRenderer
      .fetchSingle(
        'wishlist-product-card',
        `${productUrl}?variant=${product.epi}`,
      )
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('article')

        if (myself) {
          return `<div class="prd-List_Item">${myself.outerHTML.replace(
            'data-wishlist-page-el="remove"',
            `data-wishlist-page-el="remove" hidden`,
          )}</div>`
        }
      })
      .catch(() => {
        return null
      })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log(`Wishlist error: ${errorMessage}`);

    this.els['page-loading'].element.setAttribute('aria-hidden', true)
    this.els['page-empty'].element.setAttribute('aria-hidden', false)
    this.els['page-wishlist'].element.setAttribute('aria-hidden', true)
  }
}

if (!customElements.get('wishlist-shared-page')) {
  customElements.define('wishlist-shared-page', WishlistSharedPage)
}
